/**
 * Formato de dinero, cuotas y fechas — SOLO en el borde de UI (S2).
 * Toda la aritmética viene del motor y de @thepit/contracts; acá solo se muestra.
 */
import {
  centsToMajorString,
  DEFAULT_CURRENCY,
  formatBpsPercent,
  formatMoney as formatMoneyCents,
  formatOdds as formatOddsBp,
  parseMoneyInput,
  type Currency,
} from '@thepit/contracts';

export const LOCALE = 'es-AR';

export function formatMoney(cents: number | bigint | null | undefined, currency: Currency = DEFAULT_CURRENCY): string {
  if (cents === null || cents === undefined) return '—';
  return formatMoneyCents(BigInt(cents), currency);
}

export function formatOdds(bp: number): string {
  return bp > 0 ? formatOddsBp(bp, LOCALE) : '—';
}

export function formatPercentBp(bp: number): string {
  return formatBpsPercent(bp, LOCALE);
}

/** Monto en unidades mayores como texto plano. SSOT: viene de @thepit/contracts. */
export function formatAmountPlain(cents: number, decimals = 2): string {
  return centsToMajorString(cents, decimals);
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Intl.DateTimeFormat(LOCALE, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return '—';
  const diffMs = Date.now() - new Date(value).getTime();
  const seconds = Math.round(diffMs / 1000);
  if (seconds < 60) return `hace ${seconds}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `hace ${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `hace ${hours}h`;
  return formatDateTime(value);
}

export { parseMoneyInput };
